import axios from 'axios'
import { PageId } from '../store/page/PageStateInterface'
import { PurchaseProcessId } from '../store/payment/PaymentStateInterface'

export function buyMainOffer(
  pageId: PageId,
  purchaseProcessId: PurchaseProcessId,
  body: any,
) {
  return axios.post(
    `/secure/mollie/${pageId}/buy-main-offer/${purchaseProcessId}`,
    body,
  )
}

export function buyUpsellOffer(
  pageId: PageId,
  purchaseProcessId: PurchaseProcessId,
  body: any,
) {
  return axios.post(
    `/secure/mollie/${pageId}/buy-upsell/${purchaseProcessId}`,
    body,
  )
}
